<template>
  <v-card>
    <v-toolbar color="primary" dark flat>
      <v-toolbar-title>Edit Brand Type</v-toolbar-title>
      <v-spacer />
      <v-btn text @click="close">
        <v-icon left>
          mdi-close
        </v-icon>
        Cancel
      </v-btn>
      <v-btn text @click="save">
        <v-icon left>
          mdi-content-save
        </v-icon>
        Update
      </v-btn>
    </v-toolbar>

    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-text-field v-model="form.name" label="Brand Type Name" outlined dense
                        :error-messages="validationErrors.name" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from '@/extra-functions/axios.extra'
import { camelToSnake } from '@/lib/utils'
import { ErrorPopup, SuccessPopup } from '../../../../lib/utils'

export default {
  name: 'EditStockBrandType',
  props: {
    propTypeId: {
      type: [String, Number],
      required: true,
    },
    propTypeData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: { ...this.propTypeData },
      validationErrors: {},
    }
  },
  watch: {
    propTypeData(newData) {
      this.form = { ...newData }
      this.validationErrors = {}
    },
  },
  methods: {
    async save() {
      try {
        const payload = this.toSnakeCase(this.form)
        await axios(this.$store.state.auth.token)
          .put(`/stock-brand-types/${this.propTypeId}`, payload)
        this.$emit('close-dialog')
        this.$emit('updated')
        SuccessPopup.fire({
          title: 'Brand Type Updated',
          text: 'The brand type has been successfully updated.',
        })
      } catch (e) {
        if (e?.response?.data?.errors) {
          this.validationErrors = { ...e.response.data.errors }
          return
        }
        ErrorPopup.fire('Failed to update brand type.')
      }
    },
    close() {
      this.$emit('close-dialog')
    },
    toSnakeCase(obj) {
      return Object.keys(obj).reduce((acc, key) => {
        acc[camelToSnake(key)] = obj[key]
        return acc
      }, {})
    },
  },
}
</script>